import gql from "graphql-tag";

export const ListEvents = gql`
  query ListEvents ($limit: Int, $nextToken: String)
  {
    listEvents(limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value: id 
        text: title
        type
        competitions {
          id: competitionId
          code
          competitionType
          i18n_title
          i18n_description
        }
      }
    }
}
`;



// WEBPACK FOOTER //
// ./src/public/components/competitionFilter/graphql.js